import { useCallback, useEffect, useMemo, useState } from 'react';
import { Head, useForm } from '@inertiajs/inertia-react';
import axios from 'axios';
import { debounce } from 'lodash';
import { DateTime } from 'luxon';

import useAssistants from '@/hooks/useAssistants';

import rut from '@/helpers/rut';
import { isJuly, isWeekend } from '@/helpers/date';
import { usersAreValid } from '@/helpers/user';

import Authenticated from '@/Layouts/Authenticated';

import ValidationErrors from '@/Components/ValidationErrors';
import TypeTabs from '@/Components/ManualSale/TypeTabs';
import Select from '@/Components/Select';
import Label from '@/Components/Label';
import Input from '@/Components/Input';
import QuantitySelector from '@/Components/ManualSale/QuantitySelector';
import ProductList from '@/Components/ManualSale/ProductList';
import CouponForm from '@/Components/ManualSale/CouponForm';
import AssistantList from '@/Components/ManualSale/AssistantList';
import OrderStatus from '@/Components/OrderStatus';
import RedelcomImg from '../../../images/redelcom.png'
import CashImg from '../../../images/efectivo.png'




import ReactSwal from "react-sweetalert2";
import Swal from "sweetalert2";
import { getProductInitialData } from '@/helpers/products';
import { showJSONData } from '@/helpers/example';
import numberFormat from '@/helpers/numberFormat';
import classNames from 'classnames';
import { useAppContext } from '@/context/App';
import Form from '@/Components/UsersRegistration/Form';
import { getInputType } from '@/helpers/input';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css'
import { Inertia } from '@inertiajs/inertia';
//import Button from '@/Components/Button';


const Index = ({ store, data, flash, ...props }) => {
    // console.log('status: ', flash)
    //  console.log('redelcom status: ', props.redelcom_status)
    // console.log({props, data});
    const [ticketType, setTicketType] = useState('individual');
    const [quantity, setQuantity] = useState(1);
    const [scheduleTypes, setScheduleTypes] = useState(data.scheduleTypes);
    const [scheduleType, setScheduleType] = useState(null);
    const [schedules, setSchedules] = useState([]);
    const [schedule, setSchedule] = useState(null);
    const [date, setDate] = useState(data.date);
    const [responsibleForAssistants, setResponsibleForAssistants] = useState(false);

    const [assistants, handleChangeAssistant, setAssistants] = useAssistants({ quantity, responsibleForAssistants })


    const { isHoliday } = useAppContext()

    const [coupon, setCoupon] = useState(null);
    const [loadingSchedules, setLoadingSchedules] = useState(false);
    const [loadingScheduleTypes, setLoadingScheduleTypes] = useState(false);

    const [products, setProducts] = useState(data.products.map(product => getProductInitialData(product)));
    const [availableProducts, setAvailableProducts] = useState(data.products);

    const [loadingProducts, setLoadingProducts] = useState(false);

    const [responsibleUser, setResponsibleUser] = useState({
        name: '',
        lastname: '',
        rut: '',
        telephone: '',
        email: ''
    });

    const [totals, setTotals] = useState(null);

    const debouncedSearchScheduleTypes = useCallback(
        debounce(async (type, date) => {
            const response = await axios.get(route('api.schedule-types.get-by-type', { type, office: props.office, date }));
            setScheduleTypes(response.data.data);
            setLoadingScheduleTypes(false);
        }, 600)
    , [])

    const debouncedSearchSchedules = useCallback(
        debounce(async ({ quantity, date, scheduletype_id, time = undefined, ticketType = undefined }) => {
            const response = await axios.get(route('api.schedules.get-by-availability', { office: props.office, quantity, date, scheduletype_id, ticketType }));
            // console.log(response)
            setSchedules(response.data.data);
            setLoadingSchedules(false);

            if (ticketType === 'products') {
                setSchedule(response.data.data.find(({ branchOfficeId }) => branchOfficeId === props.office.id));
            }
        }, 600)
    , [])

    useEffect(() => {
        setScheduleTypes([]);
        setScheduleType(null);
        setLoadingScheduleTypes(true)
        debouncedSearchScheduleTypes(ticketType, date);
        setProducts(data.products.map(product => getProductInitialData(product)))
    }, [ticketType, date]);

    useEffect(() => {
        if (scheduleType?.id && quantity && !isNaN(new Date(date))) {
            setSchedule(null);
            setSchedules([]);
            setLoadingSchedules(true);
            debouncedSearchSchedules({
                quantity,
                date,
                scheduletype_id: scheduleType?.id,
                ticketType
            });
        } else {
            setSchedule(null);
            setSchedules([]);
        }
    }, [scheduleType, date])

    const { setData: setFormData, post, processing } = useForm({
        'firstName': responsibleUser?.name,
        'secondName': responsibleUser?.lastname,
        'email': responsibleUser?.email,
        'telephone': responsibleUser?.telephone,
        'terms': true,
        'schedule': schedule?.id,
        quantity,
        'coupon_code': coupon?.code,
        'coupon_id': coupon?.id,
        users: usersAreValid(assistants, quantity, responsibleForAssistants) ? (responsibleForAssistants ? [] : assistants) : [],
        'rut': responsibleUser.rut,
        date,
        productsDetails: products,
        office: props.office,
        scheduleType: scheduleType?.id,
        schedule: schedule?.id,
        order_type: 'manual-sale',
        is_responsible_for_assistants: responsibleForAssistants
    });

    useEffect(() => {
        setFormData({
            'firstName': responsibleUser?.name,
            'secondName': responsibleUser?.lastname,
            'email': responsibleUser?.email,
            'telephone': responsibleUser?.telephone,
            'terms': true,
            'schedule': schedule?.id,
            quantity,
            'coupon_code': coupon?.code,
            'coupon_id': coupon?.id,
            users: usersAreValid(assistants, quantity, responsibleForAssistants) ? (responsibleForAssistants ? [] : assistants) : [],
            'rut': responsibleUser.rut,
            date,
            productsDetails: products,
            office: props.office,
            scheduleType: scheduleType?.id,
            scheduletype_type: scheduleType?.type,
            schedule: schedule?.id,
            is_responsible_for_assistants: responsibleForAssistants
        });
    }, [responsibleUser, schedule, quantity, coupon, assistants, date, products, responsibleForAssistants, scheduleType])

    const handleChangeResponsible = (event, value = undefined) => {
        setResponsibleUser({
            ...responsibleUser,
            [event.target.name]: value !== undefined ? value : event.target.value
        })
    }

    useEffect(() => {
        if (assistants[0]?.is_autocomplete) {
            const assistant = assistants.find(({ id }) => id === 1);
            setAssistants([
                {
                    ...assistant,
                    name: responsibleUser.name,
                    rut: responsibleUser.rut,
                    lastname: responsibleUser.lastname,
                    assumed_guest: false,
                    is_autocomplete: true
                },
                ...assistants.filter(({ id }) => id !== 1)
            ])
        }
    }, [responsibleUser]);

    const ticketLimitQuantity = useMemo(() => {
        switch (ticketType) {
            case 'individual':
                setQuantity(1);
                return { min: 1, max: 9 }
            case 'group':
                setQuantity(10);
                return { min: 10, max: schedule?.maxTicketsStocks.quantity || 999999 }
            case 'birthday':
                setQuantity(1);
                return { min: 1, max: schedule?.maxTicketsStocks.birthday_quantity || 999999 }
            case 'skating_class':
                setQuantity(1);
                return { min: 1, max: 1 }
            case 'skating_class_monthly':
                setQuantity(1);
                return { min: 1, max: 1 }
            case 'products':
                setQuantity(0);
                return { min: 0, max: 0 }
        }
    }, [ticketType, schedule]);

    const [moneyPaid, setMoneyPaid] = useState(null);
    const [change, setChange] = useState(0);

    const handleChangeCalculator = (event) => {
        const value = parseInt(event.target.value || 0);
        setMoneyPaid(value === 0 ? null : value);
        setChange(value - totals?.totalWithDiscount);
    }

    const [swalPropsCalculator, setSwalPropsCalculator] = useState({});
    const [swalPropsPrint, setSwalPropsPrint] = useState({});
    const [swalErrorPayment, setSwalErrorPayment] = useState({});

    const handleManualSaleCheckForm = async (callback = () => {}) => {
        try {
            const response = await axios.post(route('api.manual-sale-check-form'), { schedule: schedule?.id, scheduleType: scheduleType?.id, quantity, ticketType });

            if (response.status === 200) {
                callback();
            }
        } catch (error) {
            if (error?.response?.data?.code === 'not-quota') {
                Swal.fire({
                    icon: 'error',
                    title: 'No quedan suficientes cupos',
                    text: `El máximo de cupos es ${error.response.data.data}`
                });
                return;
            }

            Swal.fire({
                icon: 'error',
                title: 'Se ha producido un error inesperado',
                text: `Por favor, intenta nuevamente. Si el problema persiste, te recomendamos contactar con un administrador del sistema para recibir asistencia técnica`
            });

            console.log({ error })
        }
    }

    const handleSubmit = async (event, type) => {
        event.preventDefault();

       if( totals?.totalWithDiscount < 50){
            return setSwalErrorPayment({
                show: true,
                title: 'Lo sentimos',
                text: 'El pago ingresado debe ser superior a $50',
                confirmButtonText: "Aceptar",
                didClose: () => {
                    setSwalErrorPayment({});
                }
            })
        }
        if (!checkIfCanSubmit()) {
            return;
        }

        const routeName = ticketType === 'products' ? 'order.manual-store.product-order' : 'order.manual-store';

        if (type === 'cash') {
            setSwalPropsCalculator({
                show: true,
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonText: "Confirmar",
                didClose: () => {
                    setSwalPropsCalculator({});
                },
                onConfirm: async () => {
                    await handleManualSaleCheckForm(() => {
                        post(route(routeName, {
                            office: props.office.slug,
                            order_type: 'manual-sale',
                            manual_type: 'cash'
                        }));
                    });
                },
            });
            return;
        }

        await handleManualSaleCheckForm(() => {
            post(route(routeName, {
                office: props.office,
                order_type: 'manual-sale',
                manual_type: type
            }));
        })
    }

    const checkIfCanSubmit = () => {
        if (ticketType !== 'products') {
            if (quantity < ticketLimitQuantity.min || quantity > ticketLimitQuantity.max){
                toast.error('Debes escoger una catidad correcta de tickets')
                return false;
            }
            if (isNaN(new Date(date))){
                toast.error('Debes ingresar una fecha')
                return false;
            }
            if (!scheduleType?.id){
                toast.error('Debes seleccionar un periodo')
                return false;
            }
            if (!responsibleUser?.name || !responsibleUser?.lastname || !responsibleUser?.rut){
                toast.error('Debes llenar todos los campos para continuar')
                return false;
            }
            if (!usersAreValid(assistants, quantity, responsibleForAssistants)){
                toast.error('Debes llenar los responsables o poner como responsable al dueño de la orden')
                return false;
            }

            if ((ticketType !== 'skating_class' && ticketType !== 'skating_class_monthly')) {
                if (!schedule?.id){
                    toast.error('Hubo un error en la selección')
                    return false;
                }
            }
        }

        return true;
    }

    const checkIfCanShowOrderStatus = () => {
        if (ticketType !== 'products') {
            if (!scheduleType || !date || !quantity) {
                return false;
            }

            if ((ticketType !== 'skating_class' && ticketType !== 'skating_class_monthly') && !schedule?.startTime) {
                return false;
            }
        }

        return true;
    }

    const [canSubmit, setCanSubmit] = useState(false);
    const [showOrderStatus, setShowOrderStatus] = useState(false);

    useEffect(() => {
        //setCanSubmit(checkIfCanSubmit())
    }, [quantity, ticketLimitQuantity, date, scheduleType, schedule, responsibleUser, assistants, assistants.length, responsibleForAssistants])

    useEffect(() => {
        setShowOrderStatus(checkIfCanShowOrderStatus())
    }, [scheduleType, date, quantity, schedule])

    useEffect(() => {
        setLoadingProducts(true);
        (async () => {
            if (schedule?.id) {
                try {
                    const response = await axios.get(route('api.products.get-manual-stocks-by-schedule', { schedule: schedule.id }));
                    setAvailableProducts([
                        ...data.products,
                        ...response.data.products
                    ].sort((a, b) => a.id - b.id))
                } catch (error) {}
            } else {
                setAvailableProducts(data.products)
            }

            setLoadingProducts(false);
        })()
    }, [schedule])

    useEffect(()=>{
        if(flash?.status === 'approved'){
            setSwalPropsPrint({
                show: true,
                title: 'La venta ha sido aprobada exitosamente',
                icon: 'success',
                confirmButtonText: 'Imprimir Ticket',
                didClose: () => {
                    setSwalPropsPrint({});
                },
                onConfirm: () => {

                    if(flash?.print){
                        Swal.fire({
                            icon: 'info',
                            title: 'Imprimiendo Voucher',
                            text: 'Espere por favor',
                            showConfirmButton: false
                        })
                        axios.post(route('point.print'), {
                            print: flash.print,
                            slug: props.office.slug,
                            orderId: flash.orderId
                        }).then(response => {
                            // console.log('response de print', response)
                            if(response.data === 'created'){
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Impresión terminada',
                                    confirmButtonText: 'Finalizar',
                                    didOpen:() => {
                                        Inertia.reload()
                                    }
                                })
                            }else{
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Error al imprimir',
                                    confirmButtonText: 'Finalizar',
                                    didOpen:() => {
                                        Inertia.reload()
                                    }
                                })
                            }
                        })
                    }
                },
            })
        }
        if(flash?.status === 'rejected' || flash?.status === 'cancelled'){
            setSwalPropsPrint({
                show: true,
                title: 'La venta ha sido rechazada, intenta nuevamente',
                text: flash?.error,
                icon: 'warning',
                didClose: () => {
                    setSwalPropsPrint({});
                },
            })
        }

        if(flash?.status === 'PAGADO'){
            setSwalPropsPrint({
                show: true,
                title: 'La venta ya ha sido pagada',
                icon: 'warning',
                didClose: () => {
                    setSwalPropsPrint({});
                },
            })
        }

        if(flash?.status === 'TERMINAL_ERROR'){
            // console.log('se activa el error de redelcom')
            setSwalPropsPrint({
                show: true,
                title: 'No hay un terminal Point configurado',
                text: 'Pide al administrador que configure tu ID de Terminal Point',
                icon: 'error',
                didClose: () => {
                    setSwalPropsPrint({});
                },
            })
        }

        if(flash?.status === 'REDELCOM_CONN_ERROR'){
            //console.log('se activa el error de redelcom')
            setSwalPropsPrint({
                show: true,
                title: 'Error de conexión con Mercadopago',
                text: 'Por favor vuelve a intentarlo, si el problema persiste comunicate con el administrador.',
                icon: 'warning',
                didClose: () => {
                    setSwalPropsPrint({});
                },
            })
        }
    },[flash])

    useEffect(() => {
        if (ticketType === 'products') {
            setLoadingProducts(true);
            debouncedSearchSchedules({ quantity, date, time: DateTime.now().toFormat('HH:mm:ss'), scheduletype_id: undefined, ticketType })
        }
    }, [ticketType, date]);

    const handleAction = (action, payload = undefined) => {
        switch(action){
            case 'SELECT_ALL':
                return selectAll();
            case 'DESELECT_ALL':
                return deselectAll();
            case 'SET_RESPONSIBLE_FOR_ASSISTANTS':
                return setResponsibleForAssistants(payload)
        }
    }

    const selectAll = () => {
        const firstAssistant = assistants.find(({ id }) => id === 1);
        setAssistants([
            {
                ...firstAssistant,
                assumed_guest: false
            },
            ...assistants.filter(({ id }) => id !== 1).map((assistant) => ({
                ...assistant,
                assumed_guest: false,
            }))
        ]);
    }
    const deselectAll = () => {
        const firstAssistant = assistants.find(({ id }) => id === 1);
        setAssistants([
            {
                ...firstAssistant,
                assumed_guest: !firstAssistant.is_autocomplete,
                rut: !firstAssistant.is_autocomplete ? '' : firstAssistant.rut
            },
            ...assistants.filter(({ id }) => id !== 1).map((assistant) => ({
                ...assistant,
                assumed_guest: true,
                rut: ''
            }))
        ]);
    }

    const getScheduleSelectLabel = (schedule, scheduleType) => {
        const startHour = DateTime.fromSQL(schedule.startTime).toFormat('HH:mm');
        const endHour = scheduleType ? (scheduleType?.duration > 0 ? DateTime.fromSQL(schedule.startTime).plus({ hours: scheduleType?.duration }).toFormat('HH:mm') : null) : null;

        if (startHour && endHour) {
            return `${startHour} a ${endHour}`
        }

        if (startHour && !endHour) {
            return startHour
        }

    }

    return (
        <Authenticated
            branchOffice={props.office}
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight flex justify-between items-center">
                <p>
                    Crear venta manual
                </p>
                <p>
                    Redelcom ID: <span
                        className={classNames({
                            "text-green-400": Boolean(props.auth.user?.redelcom_terminal),
                            "text-red-400": !Boolean(props.auth.user?.redelcom_terminal)
                        })}
                    >
                        {props.auth.user?.redelcom_terminal || 'No configurado'}
                    </span>
                </p>
            </h2>}
        >
            <Head title={`Crear venta manual - ${store === 'cerogrado' ? 'Cerogrado' : 'Trampoline Park'}`} />

            <ToastContainer />

            <ReactSwal {...swalPropsCalculator}>
                {swalPropsCalculator?.show && (
                    <div>
                        <p className="mb-3">
                            ¿Cuál es el monto a pagar?
                        </p>
                        <Input className="mx-auto mb-3" name="money_paid" value={moneyPaid} handleChange={handleChangeCalculator} type="number" />
                        <p>
                            {change <= 0 ? `No es suficiente dinero, aun faltan $${numberFormat(Math.abs(change), 0, '', '.')}` : `Vuelto a dar: $${numberFormat(change, 0, '', '.')}`}
                        </p>
                    </div>
                )}
            </ReactSwal>

            <ReactSwal {...swalPropsPrint}></ReactSwal>
            <ReactSwal {...swalErrorPayment}></ReactSwal>

            <form onSubmit={handleSubmit} className="max-w-2xl mx-auto py-8 px-4">
                <ValidationErrors errors={props.errors} />

                <TypeTabs
                    type={ticketType}
                    onChange={(type) => {
                        if (type === ticketType) {
                            setLoadingScheduleTypes(true)
                            debouncedSearchScheduleTypes(ticketType, date);
                            return;
                        }
                        setScheduleTypes(null);
                        setScheduleType(null);
                        setTicketType(type);

                        if (type === 'products') {
                            setDate(DateTime.now().toFormat('yyyy-MM-dd'));
                        }
                    }}
                    className="mb-8 grid grid-cols-2 sm:grid-cols-5 gap-2"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                    {/* {ticketType !== 'products' && ( */}
                        <>
                            <div>
                                <Label forInput="date" value="Fecha" />
                                <Input className="w-full" name="date" type="date" handleChange={(event) => setDate(event.target.value)} value={date} />
                            </div>
                            {ticketType !== 'products' && (
                                <div>
                                    <div>
                                        <Label value="Periodo de agendamiento" />
                                        <Select
                                            placeholder="Seleccione un periodo..."
                                            value={scheduleType ? {
                                                value: scheduleType,
                                                label: scheduleType?.schedule_description
                                            } : null}
                                            options={scheduleTypes?.map(({ id, schedule_description }) => ({
                                                value: scheduleTypes.find(scheduleType => scheduleType.id === id),
                                                label: schedule_description,
                                            }))}
                                            onChange={({ value }) => setScheduleType(value)}
                                            noOptionsMessage={() => {
                                                if (loadingScheduleTypes) {
                                                    return (
                                                        <div role="status">
                                                            <svg style={{ fill: 'rgba(17, 24, 39, 1)' }} aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin" viewBox="0 0 100 101" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                                            </svg>
                                                            <span className="sr-only">Espere un momento...</span>
                                                        </div>
                                                    )
                                                }

                                                if (!ticketType) {
                                                    return 'Debe seleccionar el tipo de ticket'
                                                }

                                                return 'No hay opciones disponibles'
                                            }}
                                        />
                                    </div>
                                    {!scheduleType?.hasQuotaForClasses && (scheduleType?.type === 'skating_class' || scheduleType?.type === 'skating_class_monthly') && (
                                        <small className='text-red-500'>No quedan cupos de clase {scheduleType.type === 'skating_class' ? 'diaria' : 'mensual'}</small>
                                    )}
                                </div>
                            )}
                        </>
                    {/* )} */}
                    {/* {(ticketType !== 'skating_class' && ticketType !== 'skating_class_monthly') && ticketType !== 'products' && ( */}
                    {(ticketType !== 'skating_class' && ticketType !== 'skating_class_monthly') && (
                        <div>
                            <Label value="Hora de agendamiento" />
                            <Select
                                placeholder="Seleccione una hora..."
                                value={(schedule) ? {
                                    value: schedule,
                                    label: getScheduleSelectLabel(schedule, scheduleType)
                                }: null}
                                options={schedules?.map(({ id, ...schedule }) => ({
                                    value: schedules.find(schedule => schedule.id === id),
                                    label: getScheduleSelectLabel(schedule, scheduleType)
                                }))}
                                onChange={({ value }) => setSchedule(value)}
                                noOptionsMessage={() => {
                                    if (scheduleType?.id && quantity && !isNaN(new Date(date)) && loadingSchedules) {
                                        return (
                                            <div role="status">
                                                <svg style={{ fill: 'rgba(17, 24, 39, 1)' }} aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin" viewBox="0 0 100 101" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                                </svg>
                                                <span className="sr-only">Espere un momento...</span>
                                            </div>
                                        )
                                    }

                                    if (!scheduleType?.id || !quantity || isNaN(new Date(date))) {
                                        return 'Debe seleccionar la fecha y el periodo de agendamiento'
                                    }

                                    return 'No hay opciones disponibles'
                                }}
                            />
                        </div>
                    )}
                    {ticketType !== 'products' && (
                        <div>
                            <Label value="Cantidad de tickets" />
                            <QuantitySelector style={{ height: '42px' }} min={ticketLimitQuantity.min} max={ticketLimitQuantity.max} value={quantity} onChange={(value) => setQuantity(value)} />
                        </div>
                    )}
                </div>

                {ticketType !== 'products' && (
                    <div className="mb-8">
                        <h2 className="text-xl mb-4">Datos del responsable</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                            <div>
                                <Label value="Nombre" />
                                <Input className="w-full" name="name" type="text" handleChange={handleChangeResponsible} value={responsibleUser.name} />
                            </div>
                            <div>
                                <Label value="Apellido" />
                                <Input className="w-full" name="lastname" type="text" handleChange={handleChangeResponsible} value={responsibleUser.lastname} />
                            </div>
                            <div>
                                <Label value="R.U.N" />
                                <Input className="w-full" name="rut" type="text" handleChange={(event) => handleChangeResponsible(event, rut.format(event.target.value) === '-' ? '' : rut.format(event.target.value))} value={responsibleUser.rut} />
                            </div>

                        </div>
                        <div className="flex gap-1 items-center">
                            <Input
                                id="responsible_for_assistants"
                                required
                                name="name"
                                type="checkbox"
                                handleChange={(event) => handleAction('SET_RESPONSIBLE_FOR_ASSISTANTS', event.target.checked)}
                            />
                            <Label forInput="responsible_for_assistants" value="Se hace responsable de toda la orden" />
                        </div>
                    </div>
                )}

                {!responsibleForAssistants && ticketType !== 'products' && (
                    <AssistantList responsibleUser={responsibleUser} className="mb-8" assistants={assistants} onChange={handleChangeAssistant} onAction={handleAction} quantity={quantity} />
                )}

                {(ticketType !== 'skating_class' && ticketType !== 'skating_class_monthly') && (
                    <ProductList ticketType={ticketType} loadingProducts={loadingProducts} className="mb-8" products={availableProducts} onChange={(products) => setProducts(products)} ticketsQuantity={quantity} />
                )}
                {ticketType !== 'products' && (
                    <CouponForm className="mb-8" onChange={(coupon) => setCoupon(coupon)} office={props.office} />
                )}

                {/* {schedule?.startTime && date && scheduleType && scheduleType?.weekend_price && scheduleType?.price && quantity && (
                    <div className="flex justify-center items-center mb-8">
                        <OrderStatus
                            couponDiscountTotalWithProducts={props.COUPON_DISCOUNT_TOTAL_WITH_PRODUCTS}
                            date={date}
                            time={DateTime.fromSQL(schedule?.startTime).toFormat('HH:mm')}
                            office={props.office}
                            price={(isWeekend(schedule?.startTime) || isJuly(schedule?.startTime) || isHoliday(schedule?.startTime)) ? scheduleType?.weekend_price : scheduleType?.price}
                            productsDetails={products}
                            quantity={quantity}
                            scheduleType={scheduleType}
                            discountPercent={coupon?.percent}
                            onPrices={(prices) => setTotals(prices)}
                        />
                    </div>
                )} */}

                {showOrderStatus && (
                    <div className="mb-8">
                        <OrderStatus
                            isProductOrder={ticketType === 'products'}
                            className="mx-auto"
                            office={props.office}
                            date={date}
                            discountPercent={coupon?.percent}
                            time={schedule?.startTime ? DateTime.fromSQL(schedule?.startTime).toFormat('HH:mm') : undefined}
                            scheduleType={scheduleType}
                            quantity={quantity}
                            price={(isWeekend(schedule?.startTime) || isJuly(schedule?.startTime) || isHoliday(schedule?.startTime)) ? scheduleType?.weekend_price : scheduleType?.price}
                            productsDetails={products}
                            couponDiscountTotalWithProducts={props.COUPON_DISCOUNT_TOTAL_WITH_PRODUCTS}
                            onPrices={(prices) => {
                                setTotals(prices);
                                setChange(prices.totalWithDiscount * -1);
                            }}
                        />
                    </div>
                )}


                {/* <div className="w-full flex justify-center items-center">
                    <Button className="mx-auto" processing={!canSubmit || processing}>Crear venta</Button>
                </div> */}
                {/* <div className="w-full flex justify-evenly items-center">
                    <button className="w-1/3 relative rounded-3xl overflow-hidden bg-white"
                        onClick={(e) => { handleSubmit(e, 'redelcom') }}
                    >
                        <img className="w-full" src={RedelcomImg} alt="" />
                        <p className=" font-bold text-xl">Pago <br /> electrónico</p>
                    </button>
                    <button className="w-1/3 bg-white rounded-3xl"
                        onClick={(e) => { handleSubmit(e, 'cash') }}
                    >
                        <img className="w-full" src={CashImg} alt="" />
                        <p className=" font-bold text-xl">Pago <br /> efectivo</p>
                    </button>
                </div> */}
                <div className="w-full gap-16 max-w-lg mx-auto grid grid-cols-1 sm:grid-cols-2 justify-items-center items-center">
                    <button style={{ maxWidth: '220px' }} className="w-full relative rounded-3xl overflow-hidden bg-white"
                        onClick={(e) => { handleSubmit(e, 'redelcom') }}
                    >
                        <img className="w-full" src={RedelcomImg} alt="" />
                        <p className=" font-bold text-xl">Pago <br /> electrónico</p>
                    </button>
                    <button style={{ maxWidth: '220px' }} className="w-full bg-white rounded-3xl"
                        onClick={(e) => { handleSubmit(e, 'cash') }}
                    >
                        <img className="w-full" src={CashImg} alt="" />
                        <p className=" font-bold text-xl">Pago <br /> efectivo</p>
                    </button>
                </div>
            </form>
        </Authenticated>
    )
}

export default Index;
